/**
 * 楼层管理 接口
 * @author yangyu
 */
export default {
    BASE_URL: '/cms/floor',
    api: [
        {
            name: 'list',
            desc: '楼层列表',
            method: 'GET',
            path: 'list'
        },
        {
            name: 'detail',
            desc: '楼层详情',
            method: 'GET',
            path: 'detail'
        },
        // {
        //     name: 'cataList',
        //     desc: '获取商品分类',
        //     method: 'GET',
        //     path: 'pubCata'
        // },
        {
            name: 'brandList',
            desc: '获取品牌列表',
            method: 'GET',
            path: 'pubBrand'
        },
        {
            name: 'spuList',
            desc: '获取spu列表',
            method: 'POST',
            path: 'pubSpuList'
        },
        {
            name: 'providerList',
            desc: '获取供应商列表',
            method: 'POST',
            path: 'findOrgs'
        },
        {
            name: 'add',
            desc: '新增楼层',
            method: 'GET',
            path: 'addFloor/{name}'
        },
        {
            name: 'changeSort',
            desc: '改变楼层排序',
            method: 'POST',
            path: 'upSort'
        },
        {
            name: 'save',
            desc: '保存楼层',
            method: 'POST',
            path: 'saveFloor'
        },
        {
            name: 'delete',
            desc: '删除楼层',
            method: 'GET',
            path: 'deleteFloor/{id}'
        },
        {
            name: 'toggleEnable',
            desc: '启用/禁用',
            method: 'POST',
            path: 'changeStatus'
        }
    ]
}



// WEBPACK FOOTER //
// ./src/api/apis/cms/floor.js